import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import Link from 'components/shared/Link'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { TIMETABLE_ZYRARDOW_LINK } from 'constants/links'
import { useMemo } from 'react'
import { ShuttleInfoProps } from './ShuttleInfo.types'

export const ShuttleInfo = ({ departurePlace }: ShuttleInfoProps) => {
    const dedicatedTimetable = useMemo(() => {
        switch (departurePlace) {
            case 'zyrardow':
                return TIMETABLE_ZYRARDOW_LINK
            default:
                return undefined
        }
    }, [departurePlace])

    return (
        <Box mt={16}>
            <Info
                color="info_warning"
                align={['flex-start', 'center']}
                hasBorder
                hasNoBackground
            >
                <>
                    <FormattedMessage
                        id="upsells.bus.shuttle_route_info"
                        defaultMessage="_"
                    />
                    {!!dedicatedTimetable && (
                        <Link
                            variant="secondary"
                            icon={null}
                            path={dedicatedTimetable}
                            target="_blank"
                            data-testid="transport-redirect-timetable"
                        >
                            <Text variant="bodySmallStrong">
                                <FormattedMessage
                                    id="upsells.bus.schedule_link"
                                    defaultMessage="Sprawdź rozkład"
                                />
                            </Text>
                        </Link>
                    )}
                </>
            </Info>
        </Box>
    )
}

ShuttleInfo.displayName = 'ShuttleInfo'
